import { graphql } from "react-relay";

export const QUERY = graphql`
	query personalizedNotificationTemplateEdit_Query($id: ID!) {
		node(id: $id) {
			... on PersonalizedNotificationTemplate {
				...personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment
			}
		}
	}
`;

export const PERSONALIZED_NOTIFICATION_TEMPLATE_FRAGMENT = graphql`
	fragment personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment on PersonalizedNotificationTemplate {
		id
		template {
			key
			title
			message
			variables
		}
	}
`;

export const EDIT_PERSONALIZED_NOTIFICATION_TEMPLATE_MUTATION = graphql`
	mutation personalizedNotificationTemplateEdit_EditPersonalizedNotificationTemplateMutation(
		$input: EditPersonalizedNotificationTemplateInput!
	) {
		Admin {
			Notification {
				editPersonalizedNotificationTemplate(input: $input) {
					edge {
						node {
							...personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment
						}
					}
				}
			}
		}
	}
`;
